const criar_turma_do_planejamento = {
  path: "/criar-turma-do-planejamento",
  redirect: "/criar-turma-do-planejamento",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Criar Turmas do Planejamento",
  },
  children: [
    {
      path: "/criar-turma-do-planejamento",
      name: "criar_turma_do_planejamento",
      component: () =>
        import("@/views/CriarTurmasPlanejamento/CriarTurmasPlanejamento.vue"),
    },
  ],
};

export { criar_turma_do_planejamento };
